<div
  class="container waterstamp"
  [ngClass]="
    activeLang === 'sv'
      ? isTestable
        ? 'test-waterstamp-sv'
        : 'preview-waterstamp-sv'
      : isTestable
        ? 'test-waterstamp-en'
        : 'preview-waterstamp-en'
  "
>
  @if (formTitle) {
    <div class="form-header mt-4">
      <h1 class="mb-2">{{ formTitle }}</h1>
      <hr class="mb-4" />
    </div>
  }
  @if (parsedForm$ | async; as parsedForm) {
    <lib-dynamic-form
      [formGroup]="parsedForm"
      [showAllFollowUps]="!isTestable"
      [previewMode]="!isTestable"
    ></lib-dynamic-form>
  }
</div>
